<template>
  <div class="industry-pillar">
    <title-one :title="title || ''" :ps-txt="psTxt" />
    <div class="rank-two left">
      <progress-item
        v-for="(item, index) in list || []"
        :key="index"
        :progress="item | changeProgress(total || 0)"
      />
    </div>
  </div>
</template>

<script>
import TitleOne from '@/components/TitleOne/TitleOne'
import ProgressItem from '@/views/Home/components/ProgressItem'
export default {
  name: 'IndustryPillar',
  components: { ProgressItem, TitleOne },
  filters: {
    changeProgress: (value, total) => {
      return {
        ...value,
        per: total === 0 ? '0%' : `${(value.num * 100 / total).toFixed(2)}%`,
        total: total
      }
    }
  },
  props: {
    title: {
      type: String,
      default: () => ''
    },
    psTxt: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="less" scoped>
  .rank-two{
    width: 100%;
    height: 313px;
    padding: 24px 40px 20px;
    background: url("../../images/left-2.png") top left no-repeat;
    background-size: 100% 100%;
    color: #fff;
    overflow: hidden;
  }
  .left{
    position: relative;
    top: -6px;
  }
</style>
